// Centralized API configuration
// All API URL references should import from this file

// Production API URL
export const API_URL = '/api';
export const API_BASE_URL = API_URL;

// Socket URL (without /api path)
export const SOCKET_URL = API_URL.replace('/api', '');

// Helper to get full API endpoint
export const getApiEndpoint = (path) => `${API_URL}${path.startsWith('/') ? path : '/' + path}`;

export default API_URL;
